import { mainSiteUrl } from '@/mocks/categories';
import { trustBadges } from '@/mocks/homepage';

export default function Hero() {
  return (
    <section data-product-shop className="relative w-full min-h-[620px] md:min-h-[720px] flex items-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20editorial%20product%20photography%20featuring%20a%20curated%20collection%20of%20modern%20fashion%20pieces%20including%20sneakers%20leather%20accessories%20and%20textiles%20arranged%20in%20an%20organic%20flowing%20composition%20on%20a%20warm%20sand%20colored%20surface%20with%20soft%20natural%20window%20light%20creating%20gentle%20subtle%20shadows%20elegant%20European%20lifestyle%20brand%20aesthetic%20sophisticated%20contemporary%20feel%20with%20muted%20warm%20tones%20and%20harmonious%20color%20palette&width=1920&height=900&seq=hero-bg-oopbuy-v2&orientation=landscape"
          alt="Oopbuy Spreadsheet Produkte"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/25 z-[1]"></div>

      <div className="relative z-10 w-full px-4 md:px-6 lg:px-10">
        <div className="max-w-3xl">
          <span className="inline-block px-3 py-1.5 mb-5 text-xs font-medium tracking-wider uppercase rounded-full border border-white/30 text-white/90 backdrop-blur-sm">
            Oopbuy Spreadsheet 2026
          </span>
          <h1 className="text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-heading font-semibold text-white leading-tight mb-4">
            Der smarte Weg zum<br />
            <span className="text-primary-300">Oopbuy Spreadsheet</span>
          </h1>
          <p className="text-base md:text-lg text-white/80 max-w-xl mb-8 leading-relaxed">
            Über 1000 kuratierte Produkte aus 14 Kategorien. QC-geprüft, zolloptimiert und direkt nach Deutschland geliefert — mit dem Oopbuy Spreadsheet.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 mb-10">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="px-6 py-3 text-sm font-semibold rounded-lg bg-primary-500 text-background-50 hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer inline-flex items-center justify-center gap-2 w-full sm:w-auto"
            >
              buy it now
              <i className="ri-arrow-right-line"></i>
            </a>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="px-6 py-3 text-sm font-semibold rounded-lg bg-white/15 backdrop-blur-sm text-white border border-white/25 hover:bg-white/25 transition-all whitespace-nowrap cursor-pointer inline-flex items-center justify-center gap-2 w-full sm:w-auto"
            >
              oopbuy spreadsheet
              <i className="ri-external-link-line"></i>
            </a>
          </div>

          <div className="flex flex-wrap gap-6 md:gap-8">
            {trustBadges.map((badge) => (
              <div key={badge.text} className="flex items-center gap-2">
                <span className="w-7 h-7 flex items-center justify-center rounded-full bg-white/15">
                  <i className={`${badge.icon} text-white text-sm`}></i>
                </span>
                <span className="text-xs md:text-sm text-white/80 font-medium whitespace-nowrap">{badge.text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}